import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  ISecondSectionPayload,
  ISecondSectionResponse,
  ActionType,
} from "models/dashboard/secondSection";
import { httpStatus } from "configs/httpStatus";
import { fetchSecondSectionData } from "services/dashboard";
import { handleSuccesAction, handleErrorAction } from "./secondSectionActions";

function* getSecondSectionSaga({
  payload,
}: {
  payload: ISecondSectionPayload;
}) {
  try {
    const response: ISecondSectionResponse = yield call(
      fetchSecondSectionData,
      payload
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetSecondSectionWatcher() {
  yield takeLatest(
    ActionType.GET_SECOND_SECTION_DATA as any,
    getSecondSectionSaga
  );
}

export default [fork(onGetSecondSectionWatcher)];
